export const AllSteps = [
    {value:"", label:"Selecione..."},
    {value:"1", label:"Em Análise Financeira"},
    {value:"2", label:"Em Mapeamento de Oportunidades"},
    {value:"3", label:"Em Pleito de Solicitação"},
    {value:"4", label:"Em Prestação de Contas"},
    // {value:"notStarted", label:"Não Iniciado"},
    // {value:"opening", label:"Em Abertura de Missão"},
    // {value:"mapping", label:"Em fase de Mapeamento"},
    // {value:"lawsuit", label:"Em fase de Pleito"},
    // {value:"contracting", label:"Em fase de Contratação"},
    // {value:"accountability", label:"Em fase de Prestação de Contas"},
]